import React, { useEffect } from 'react';
import { motion, useAnimation } from 'framer-motion';

const DonationButton = () => {
    const controls = useAnimation();

    useEffect(() => {
        let mounted = true;

        const startBounce = async () => {
            await new Promise(resolve => setTimeout(resolve, 3000)); // espera 3 segundos
            while (mounted) {
                await controls.start({
                    scale: [1, 1.2, 1],
                    transition: { duration: 1.2, ease: "easeInOut" }
                });
                await new Promise(resolve => setTimeout(resolve, 10000));
            }
        };

        // Ejecuta después de que el componente está montado en el siguiente frame
        requestAnimationFrame(() => {
            if (mounted) {
                startBounce();
            }
        });

        return () => {
            mounted = false;
        };
    }, [controls]);

    return (
        <motion.button
            animate={controls}
            whileHover={{ scale: 1.09 }}
            whileTap={{ scale: 0.95 }}
            className="my-6 text-lg mt-8 uppercase font-lato bg-ipink text-white font-bold py-1 px-3 rounded-lg inline-flex items-center shadow-lg hover:shadow-xl transition-all hover:bg-idarkpink focus:outline-none focus:ring-4 focus:ring-pink-300 transform active:scale-95"
            onClick={() => {
                document.getElementById('donation-amounts')?.scrollIntoView({
                    behavior: 'smooth'
                });
            }}
        >
            Donar ahora
        </motion.button>
    );
};

export default DonationButton;
